module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductMetersCalculator":{"calculationText":"Celkem obdržíte {square} m<sup>2</sup> v celkové hodnotě {price}.","label":{"width":"Zvolte šířku","length":"Zvolte délku"},"notificationMaxAmountReached":"","price":{"square":"{price}<span>/m<sup>2</sup>","totalWithTax":"včetně DPH","totalWithouTax":"bez DPH","unit":"Cena"}}},"de":{},"sk":{}}')
  delete Component.options._Ctor
}
